// Development-only logging helpers.
//
// The production build must never emit diagnostic output: those logs have
// historically carried sensitive payloads (auth sessions with access/refresh
// tokens, full user objects, and query results with customer data), which an
// observer on a shared machine could read from the console (CWE-532).
//
// These helpers no-op unless NODE_ENV is a non-production build, so diagnostics
// stay available locally while shipping nothing to end users. Even in
// development, never pass a Supabase `session` object here — it contains tokens.
const isDev = process.env.NODE_ENV !== 'production';

export const devLog = (...args) => {
  if (isDev) console.log(...args);
};

export const devWarn = (...args) => {
  if (isDev) console.warn(...args);
};
